import { Clock, FileImage, Eye } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { ExecutionOrder } from '@/pages/app/PlantExecution';

interface OrderQueueListProps {
  orders: ExecutionOrder[];
  selectedOrder: ExecutionOrder | null;
  compact: boolean;
  searchQuery: string;
  onSelect: (order: ExecutionOrder) => void;
  onViewDesign: (order: ExecutionOrder) => void;
  onViewOrder: (order: ExecutionOrder) => void;
}

export default function OrderQueueList({
  orders,
  selectedOrder,
  compact,
  searchQuery,
  onSelect,
  onViewDesign,
  onViewOrder,
}: OrderQueueListProps) {
  if (orders.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500">
        <Clock className="h-8 w-8 mx-auto mb-2 opacity-50" />
        <p>{searchQuery ? 'No se encontraron órdenes' : 'No hay órdenes asignadas'}</p>
      </div>
    );
  }

  return (
    <>
      {orders.map((order) => (
        <div
          key={order.id}
          className={`transition-all duration-200 border-l-4 ${compact ? 'p-2' : 'p-4'} ${
            selectedOrder?.id === order.id
              ? 'bg-gradient-to-r from-blue-50 to-blue-100 shadow-md border-blue-600'
              : 'hover:bg-gray-50 border-transparent'
          }`}
        >
          <button onClick={() => onSelect(order)} className="w-full text-left">
            <div
              className={`font-semibold ${compact ? 'text-xs' : 'text-sm'} ${
                selectedOrder?.id === order.id ? 'text-blue-900' : 'text-gray-900'
              }`}
            >
              {order.orderNumber}
            </div>
            {!compact && (
              <>
                <div className="text-xs text-gray-600 mt-1">{order.productName}</div>
                <div className="text-xs text-gray-500 mt-1">Cliente: {order.customerName}</div>
                {order.lotCode && (
                  <div className="text-xs text-gray-700 mt-1 font-medium">Lote: {order.lotCode}</div>
                )}
                {order.machineName && (
                  <div className="text-xs text-blue-600 mt-1 font-medium">
                    Máquina: {order.machineName}
                  </div>
                )}
              </>
            )}
          </button>
          {!compact && (
            <div className="space-y-2">
              <Button
                size="sm"
                variant="outline"
                className="w-full text-purple-600 hover:text-purple-700 text-xs"
                onClick={() => onViewDesign(order)}
                title="Ver Diseño"
              >
                <FileImage className="w-3 h-3 mr-1" />
                Ver Diseño
              </Button>
              <Button
                size="sm"
                variant="outline"
                className="w-full text-blue-600 hover:text-blue-700 text-xs"
                onClick={() => onViewOrder(order)}
                title="Ver Orden"
              >
                <Eye className="w-3 h-3 mr-1" />
                Ver Orden
              </Button>
            </div>
          )}
        </div>
      ))}
    </>
  );
}
